import { RoutePaths } from '../../../../shared/helpers/routes';

export const TopNavbarTitles = {
  // login: 'Увійти',
  call_to_action: 'Почніть свій проект',
};

export const navBarItemTitlesArray = [
  {
    itemName: 'Послуги',
    routePath: RoutePaths.services,
    storeItemName: 'Магазин',
  },
  {
    itemName: 'Про нас',
    routePath: RoutePaths.aboutUsPage,
  },
  {
    itemName: 'Контакти',
    routePath: RoutePaths.contactsPage,
  },
  {
    itemName: 'Обране',
    routePath: RoutePaths.favourites,
  },
  // {
  //   itemName: 'Вхід',
  //   routePath: RoutePaths.loginPage,
  // },
  {
    itemName: 'Почніть свій проект',
    routePath: RoutePaths.leadForm,
  },
];



export const mobileNavBarItemTitlesArray = {
  itemNameLeadForm: 'Почніть свій проект',
    routePathLeadForm: RoutePaths.leadForm,
  
  itemNameServices: 'Послуги',
  routePathServices: RoutePaths.services,
  
  itemNameAbout: 'Про нас',
  routePathAbout: RoutePaths.aboutUsPage,

  itemNameContacts: 'Контакти',
  routePathContacts: RoutePaths.contactsPage,

  itemNameFavourite: 'Обране',
  routePathFavourite: RoutePaths.favourites,
};